/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

const ICONS = [
  "ec2",
  "dynamodb",
  "sqs",
  "lambda",
  "route53",
  "s3",
  "codepipeline",
  "kms",
  "rds",
  "ecs",
  "apigateway",
  "ecr",
  "sns",
  "redshift",
  "appsync",
  "waf",
  "secretsmanager",
  "amplify",
  "athena",
  "autoscaling",
  "cloudfront",
  "codebuild",
  "cognito-idp",
  "datapipeline",
  "elasticache",
  "elasticfilesystem",
  "elasticloadbalancing",
  "elasticmapreduce",
  "es",
  "firehose",
  "glue",
  "iam",
  "kinesis",
  "machinelearning",
  "sagemaker",
  "securityhub",
];

export const SUBICONS = {
  "reserved-instances": "reservedInstance",
} as const;

export const ParseResourceType = (type: string): [string, string] => {
  const [family, ...rest] = type.split("/");
  return [
    family.replaceAll(/.googleapis.com/g, "").replaceAll(/microsoft./g, ""),
    rest.join("/"),
  ];
};

export const FamilyHasIcon = (family: string) => ICONS.includes(family);

export const SubtypeHasIcon = (subtype: string) =>
  Object.keys(SUBICONS).includes(subtype);
